import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconShevronDownSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="24" height="24" viewBox="0 0 24 24" fill="none"
             className={classNames(['svg-icon svg-shevron-down', className])}>
                <g transform="translate(-303 -719)">
                    <g transform="translate(303 719)">
                        <rect className="a" width="24" height="24"  fill="none"/>
                        <path className="b" d="M111-20l5,5,5-5Z" fill={color} transform="translate(-104 30)"/>
                    </g>
                </g>
            </svg>

    );
};

IconShevronDownSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconShevronDownSVG.defaultProps = {
    color: '#32cccc',
    className: '',
};

export default IconShevronDownSVG;